// Login.js
 
import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import Button from 'react-bootstrap/Button';
import { Form } from "react-bootstrap";
import Alert from 'react-bootstrap/Alert';
import { useState } from "react";
import titleZedLogo from './title-zedlogo.png';
import qs from 'qs';
import Card from 'react-bootstrap/Card';
 
function Login() {
  const [error, setError] = useState()
  const [showError, setShowError] = useState(false)
  const [email, setEmail] = useState('');

  const handleSubmit = ((email) => 
  {
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    if (emailRegex.test(email)) {
        setShowError(false)

        const character = "@";
        const indexOfCharacter = email.indexOf(character);
        const identifier = email.substring(indexOfCharacter + 1);

        const data = {
          client_id: process.env.REACT_APP_LOGIN_CLIENT_ID,
          response_type: process.env.REACT_APP_LOGIN_RESPONSE_TYPE,
          redirect_uri: process.env.REACT_APP_LOGIN_REDIRECT_URI,
          idp_identifier: identifier,
          login_hint: email
        };

        const redirect_uri = process.env.REACT_APP_LOGIN_ENDPOINT_URI + '?' + qs.stringify(data);
        window.location.href = redirect_uri
    } 
    else
    {
        setError(`Please enter valid email adderss`)
        setShowError(true)
    }
  })

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      handleSubmit(email)
    }
  };

  return (
          <div className="container text-center p-4">
            <div style={{flexDirection: "column", justifyContent: "center"}}>
              <img style={{ width: 475, height: 120}} src={titleZedLogo} alt="fireSpot"/>
              <h1></h1>
            </div>
            <div className="container text-center p-4" style={{flexDirection: "column", justifyContent: "center", width: 475, height: 120}}>
              {showError && (<Alert variant='danger'>{error}</Alert>)}
              <Form>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Log in to Zedmed Cloud</Form.Label>
                  <Form.Control type="email" 
                                placeholder="Enter email" value={email}
                                onChange={(e) => setEmail(e.target.value)} 
                                style={{width: 440, height: 40}}
                                onKeyDown={handleKeyDown}/>
                </Form.Group>
              </Form>
              <Button variant="primary" type="button" onClick={() => handleSubmit(email)} style={{width: 440, height: 40}}>
                Continue
              </Button>
              <div className="container text-center p-4">
                <Card.Link href="https://help.zedmed.com.au/help">Zedmed Knowledgebase</Card.Link><br/>
                <Card.Link href="https://www.zedmed.com.au/support/">Contact Zedmed Support</Card.Link><br/>
                <Card.Link href="https://www.zedmed.com.au/cloud-practice-management-software/">Find Out More About Zedmed Cloud</Card.Link>
              </div>
            </div>
          </div>
  )
}
 
export default Login;